(() => {
  const desktop = window.matchMedia('(min-width: 750px)');

  // Index of the slide currently shown: the active slide on desktop, the scrolled-to slide on mobile.
  const currentIndex = (list, items) => {
    if (!desktop.matches) {
      const left = list.scrollLeft;
      let best = 0;
      items.forEach((item, i) => {
        if (Math.abs(item.offsetLeft - left) < Math.abs(items[best].offsetLeft - left)) best = i;
      });
      return best;
    }
    const active = items.findIndex((item) => item.classList.contains('is-active'));
    return active < 0 ? 0 : active;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-media-step]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const gallery = button.closest('media-gallery');
    const list = button.closest('ul');
    if (!gallery || !list) return;

    const items = [...list.querySelectorAll(':scope > [data-media-id]')];
    if (items.length < 2) return;
    const step = Number(button.dataset.mediaStep);
    const next = items[(currentIndex(list, items) + step + items.length) % items.length];
    gallery.setActiveMedia(next.dataset.mediaId, false);
  });
})();
